<template>
  <div class="usage-widget">
    <v-chart :option="gaugeOption" autoresize class="gauge-chart" />

    <div class="center-text" :style="{ color: zoneColor }">
      <p class="label">{{ timeSpan}}</p>  
      <p class="label">{{ $t('charts.occupation.of') }}</p>
        <p class="percentage">{{ usageText }}</p>
        <p class="label">{{ $t('charts.occupation.duringOpeningHours') }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { use } from 'echarts/core'
import { GaugeChart } from 'echarts/charts'
import { TooltipComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'
import { currentLanguage } from '@/i18n'
import { formatPercent } from '@/i18n/format'

// register ECharts modules
use([GaugeChart, TooltipComponent, CanvasRenderer])

const props = defineProps({
  usage: {
    type: Number,
    required: true
  },
  zoneColor: {
    type: String,
    default: '#000'
  },
  timeSpan: {
    type: String,
    required: true
  }
})

// Format usage to 1 decimal (or integer) as you like
const formattedUsage = computed(() =>
  Math.round((props.usage ?? 0) * 10) / 10
)

// "34.5%" in English exactly as before; Dutch "34,5%".
const usageText = computed(() => currentLanguage() === 'en'
  ? `${formattedUsage.value}%`
  : formatPercent(formattedUsage.value, { decimals: Number.isInteger(formattedUsage.value) ? 0 : 1 }))

// Build the gauge option
const gaugeOption = computed(() => ({
  tooltip: { show: false },
  series: [
    {
      type: 'gauge',
      startAngle: 90,
      endAngle: -270,
      pointer: { show: false },
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        itemStyle: {
          color: props.zoneColor,
          borderWidth: 0
        }
      },
      axisLine: {
        lineStyle: {
          width: 20,
          color: [
            [formattedUsage.value / 100, props.zoneColor],
            [1, '#eee']
          ]
        }
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { show: false },
      title: { show: false },
      data: [{ value: formattedUsage.value }]
    }
  ]
}))
</script>

<style scoped>
.usage-widget {
  position: relative;
  width: 100%;
}
.gauge-chart {
  width: 100%;
  height: 460px;
}
.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.center-text .percentage {
  font-size: 32px;
  font-weight: bold;
  margin: 0;
}
.center-text .label {
  font-size: 12px;
  color: #666;
  margin: 2px 0 0;
}

</style>